// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — editor.styled.classic.js, новая — editor.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './editor.styled.classic';
import * as cp from './editor.styled.cp';

export const Content = isCp ? cp.Content : classic.Content;
export const PlaceHolder = isCp ? cp.PlaceHolder : classic.PlaceHolder;
